import { Button, FormControl, FormLabel, Input, Sheet, Typography } from "@mui/joy";
import * as React from "react";
import { serverHost } from "./const";

const LoginPage: React.FC<{ onLogin: (status: any) => void }> = ({ onLogin }) => {
  let name: string = "";
  let pwd: string = "";
  const Submit = async () => {
    const url = `http://${serverHost}/login`;
    let headers = {
      "Content-Type": "application/json",
    };

    let payload = {
      user: name,
      pwd: pwd,
    };

    try {
      const resp: Response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(payload),
      });
      if (!resp.ok) {
        console.log(await resp.text());
        alert("登录失败");
        return;
      } else {
        const j = await resp.json();
        onLogin(j);
      }
    } catch (error) {
      console.log(error);
      alert("登录失败");
    }
  };

  return (
    <main>
      <Sheet
        sx={{
          width: 400,
          mx: "auto", // margin left & right
          my: 4, // margin top & bottom
          py: 3, // padding top & bottom
          px: 2, // padding left & right
          display: "flex",
          flexDirection: "column",
          gap: 2,
          borderRadius: "sm",
          boxShadow: "md",
        }}
        variant='outlined'>
        <div>
          <Typography level='h4' component='h2'>
            <b>岱山县蓬莱森林体育公园工程远程中央控制系统</b>
          </Typography>
          <Typography>请登录</Typography>
        </div>
        <FormControl>
          <FormLabel>User</FormLabel>
          <Input
            name='user'
            onChange={(e) => {
              name = e.target.value;
            }}></Input>
        </FormControl>
        <FormControl>
          <FormLabel>Password</FormLabel>
          <Input
            type='password'
            name='pwd'
            onChange={(e) => {
              pwd = e.target.value;
            }}></Input>
        </FormControl>
        <Button sx={{ mt: 1 }} onClick={Submit}>
          登录
        </Button>
      </Sheet>
    </main>
  );
};

export default LoginPage;
